import React, { Component } from "react";
import { Router, IndexRoute, Route, browserHistory } from 'react-router';
import App from './component/App';
import Home from './pages/Home';
import Topics from './pages/topics';
import Subjects from './pages/subjects';
import Instructors from './pages/instructors';
import Admins from './pages/Admin';
import Category from './pages/category';
import SubCategory from './pages/subcategory';
import Explanations from './pages/Explanations';
import CreateQuestion from './pages/CreateQuestion';
import QuizCreation from './pages/QuizCreation';
import Courses from './pages/courses';
import Sections from './pages/sections';
import QuizList from './pages/QuizList';
import CoursesDashboard from './pages/CoursesDashboard';
import SectionsDashboard from './pages/SectionsDashboard';
import QuizScore from './pages/quizScore';
import './css/index.css';
import Test1 from './pages/Test1';
import TestScore from './pages/TestScore';
import GradebookPage from './pages/GradebookPage';
import SettingsPage from './pages/SettingsPage'
import HelpMenuCat from './pages/HelpMenuCat'
import AboutPage from './pages/AboutPage'
import HelpMenuSubCat from './pages/HelpMenuSubCat'
import HelpMenu from './pages/HelpMenu'
import PerfGraphs from './pages/PerfGraphs'
//CSS Imports
import './css/common.css';

import SubCategoryDetails from './pages/SubCategoryDetails';
import ICSMappings from './pages/InstructorDetails';
import ArchivePage from './pages/archive';
import LoginAttemptPage from './pages/LoginAttempt'
import Synchronization from './pages/Synchronization'
import NewUniversityForm from './component/NewUniversityForm';
import Properties from "./component/Properties";
import LTIQuizPage from './pages/LtiQuiz'; //LTI Changes
import SubSections from './pages/Subsections';
import SubSectionTabs from './pages/SubSectionTabs';
import StudentEnrollmentList from './pages/StudentEnrollmentList';
import SectionTabs from './pages/SectionTabs';
import axios from 'axios';
import { NotificationManager } from 'react-notifications';
import CoursesTabs from './pages/CourseTabs'
import {GetAppURL} from "./common/function";
import ActivityLog from "./pages/ActivityLog";
import Profile from "./pages/Profile";

export default class MainApp extends Component{

    constructor(props){
        super(props);
        this.state = {
            appProperties: null,
            appSetting: null
        }
        this.appSettingCallBack = this.appSettingCallBack.bind(this);
    }

    componentWillMount = async () => {
        let universityPrefix = GetPrefixUniversity();
            if (process.env.hasOwnProperty("REACT_APP_APPSETTING_REQUIRED")) {
                await this.getAppSettings(this.appSettingCallBack)
            } else {
                window.localStorage.setItem(`${universityPrefix}_CpanelAppsettings`, JSON.stringify({ ...process.env }));
                this.setState({appProperties :new Properties(),
                    appSetting :JSON.parse(window.localStorage.getItem(`${universityPrefix}_CpanelAppsettings`))});
            }

    }

    appSettingCallBack = (flag) => {
        let universityPrefix = GetPrefixUniversity();
        this.setState({appProperties :new Properties(),
            appSetting :JSON.parse(window.localStorage.getItem(`${universityPrefix}_CpanelAppsettings`))});
    }

 
    getAppSettings = async (callBack) => {
        new Promise(async(resolve , reject) => {
            let AppURL = GetAppURL();
    
            await axios.get(`${AppURL}/getCpanelAppSettings`)
                .then(function (response) {
                    if (response?.data?.data) {
                        let universityPrefix = GetPrefixUniversity();
                        window.localStorage.setItem(`${universityPrefix}_CpanelAppsettings`, JSON.stringify(response.data.data));
                        callBack(true);
                        resolve(true);
                    } else {
                        NotificationManager.error("App Setting Not Found", "ERROR!", 5000);
                        resolve(false);
                    }
                })
                .catch(function (error) {
                    console.log("App settings ERROR:",error);
                    window.location = window.location.protocol + "//" + window.location.hostname + "/not-found.html";
                    reject(error);
                })
        })
    }


    render(){
        return this.state.appProperties && this.state.appSetting && <> <RouterLoad appProperties={this.state.appProperties} AppSetting={this.state.appSetting} /> {this.props.children} </>;
    }

        
}

class RouterLoad extends Component {
    constructor(props){
        super(props);
    }

    render(){
        return (
            <Router history={browserHistory}>
                <Route path={this.props.appProperties.baseFolder} component={App}>
                    <IndexRoute component={Home} />
                    <Route path={this.props.appProperties.baseFolder + 'topics'} component={Topics} />
                    <Route
                        path={this.props.appProperties.baseFolder + 'subjects'}
                        component={Subjects}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'instructors'}
                        component={Instructors}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'admins'}
                        component={Admins}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'category'}
                        component={Category}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'subcategory'}
                        component={SubCategory}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'subcategory'}
                        component={SubCategory}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'Explanations'}
                        component={Explanations}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'createQuestion'}
                        component={CreateQuestion}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'QuizCreation'}
                        component={QuizCreation}
                    />
                    <Route path={this.props.appProperties.baseFolder + 'courses'} component={Courses} />
                    <Route
                        path={this.props.appProperties.baseFolder + 'sections'}
                        component={CoursesTabs}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'SubCategoryDetails'}
                        component={SubCategoryDetails}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'quizList'}
                        component={QuizList}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'coursesDashboard'}
                        component={CoursesDashboard}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'sectionsDashboard'}
                        component={SectionsDashboard}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'quizScore'}
                        component={QuizScore}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'test1'}
                        component={Test1}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'icsMappings'}
                        component={ICSMappings}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'testScore'}
                        component={TestScore}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'gradebook'}
                        component={GradebookPage}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'helpMenuCat'}
                        component={HelpMenuCat}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'synchronization'}
                        component={Synchronization}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'loginAttemptPage'}
                        component={LoginAttemptPage}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'AboutPage'}
                        component={AboutPage}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'PerfGraphs'}
                        component={PerfGraphs}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'helpMenuSubCat'}
                        component={HelpMenuSubCat}
                    />
                    <Route path={this.props.appProperties.baseFolder + 'helpMenu'}
                        component={HelpMenu} />
                    <Route
                        path={this.props.appProperties.baseFolder + 'archivePage'}
                        component={ArchivePage}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'settingsPage'}
                        component={SettingsPage}
                    />
                    {this.props.AppSetting.REACT_APP_UNIVERSITY_SUFFIX === 'cpanel' ?
                        <IndexRoute
                            component={NewUniversityForm}
                        />
                        : ""
                    }
                    <Route
                        path={this.props.appProperties.baseFolder + 'ltiQuiz'}
                        component={LTIQuizPage}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'subSections'}
                        component={SubSections}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'subSectionTabs'}
                        component={SubSectionTabs}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'studentEnrollmentList'}
                        component={StudentEnrollmentList}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'sectionTabs'}
                        component={SectionTabs}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'activityLog'}
                        component={ActivityLog}
                    />
                    <Route
                        path={this.props.appProperties.baseFolder + 'profile'}
                        component={Profile}
                    />
                </Route>
            </Router>
        );
    }
}

export function GetPrefixUniversity() {
    if (process.env.hasOwnProperty("REACT_APP_APPSETTING_REQUIRED")) {
        if (window.location.hostname === 'localhost') {
            return "local";
        } else {
            let hostArray = window.location.hostname.split(".");
            if (hostArray.length > 4) {
                return hostArray[hostArray.length - 5];
            } else if (hostArray.length == 4) {
                return hostArray[hostArray.length - 4];
            }
            return "local";
        }
    } else {
        return process.env.REACT_APP_UNIVERSITY_SUFFIX;
    }
}
